import { useState, useEffect } from "react";
import "./Skills.css";
import SkillItem from "./SkillItem";
import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { authFetch } from "../../helpers";

const Liked = () => {
    
        const [skillItems, setSkillItems] = useState([]);
        const { user } = useAuthContext();
        
        let userId;
        if(user !==undefined)
        userId = user.id;

        // console.log(userId);

        useEffect(() => {
            authFetch(`${API}/skills?sort=order_id&populate=*`)
              .then((resSkill) => {
                return resSkill.json();
              })
              .then((dataSkills) => {
                // console.log(dataSkills.data)
                dataSkills.data.map((item=>{
                    return item.attributes.skill_types.data
                })) 
                setSkillItems(dataSkills.data); 
                
              })
              .catch((err) => console.error("Error fetching skills:", err));
          }, []);
        //   console.log(skillItems)
    return(
        <div className="skills">
                {/* <div className="head-title"></div>
                <div className="description"></div> */}
                <div className="skills-inner">
                    <div className="filter">
                    </div>
                        {skillItems.map((item, i)=>{  
                            let itter = false;
                            item.attributes.users.data.map((userItem)=>{
                                // console.log(item.attributes.users.data.length) 
                                if(item.attributes.users.data.length > 0){
                                    if(userItem.id === userId){     
                                        itter = true;
                                    }  
                                }
                                
                            })
                            if(itter===true)
                                return (<SkillItem key={i} SklItem={item.attributes} itemId={item.id}/>)
                        })}
                </div>
            </div>
    );

}
export default Liked;